import { BankInstitutionsTransformer } from '@/common/services/bankInstitutionsTransformer'
import { BankAccountInformation } from '@/common/types/establishment/company.type'
import { UpdateEstablishmentCompanyBranchValidationSchema } from '@/features/establishments/schemas/updateEstablishmentCompanyBranch.schema'

export const updateEstablishmentCompanyBranchDefaultValues = (bankAccountInformation: BankAccountInformation) => {
  const establishmentCompanyBranchDefaultValues: UpdateEstablishmentCompanyBranchValidationSchema = {
    bank_account_information: {
      ...bankAccountInformation,
      bank_institution: BankInstitutionsTransformer.optionsTransformer()([bankAccountInformation.bank_institution])[0],
    },
  }

  return establishmentCompanyBranchDefaultValues
}
